/**
 * Shared freshness helpers — used by DiffCell (rendering) and diff construction
 * (auto-approving cells whose values are within the freshness window).
 */

export type FreshnessStatus = "fresh" | "stale" | "empty"

export function getFreshnessStatus(
  timestamp: string | null | undefined,
  freshnessDate: string | null,
): FreshnessStatus {
  if (!timestamp) return "empty"
  if (!freshnessDate) return "fresh"
  return timestamp.slice(0, 10) >= freshnessDate ? "fresh" : "stale"
}
